import React from 'react';
import { Box, Link, Typography } from '@mui/material';

export default function SearchSummary({ response, query, onOriginalSearch }) {
  return (
    <Box aria-live="polite">
      {query && (
        <Typography component="h2" variant="h5" gutterBottom>
          {response?.corrected
            ? `Including results for “${response.effectiveQuery}”`
            : `Showing offers for '${query}'`}
        </Typography>
      )}
      {response?.corrected && (
        <Link
          component="button"
          type="button"
          variant="body2"
          underline="always"
          onClick={onOriginalSearch}
          sx={{
            display: 'block',
            maxWidth: '100%',
            minHeight: 44,
            py: 1,
            textAlign: 'left',
            overflowWrap: 'anywhere',
            textUnderlineOffset: '3px',
            '&:focus-visible': {
              outline: '2px solid',
              outlineColor: 'primary.main',
              outlineOffset: 2,
            },
          }}
        >
          {`Search only for “${query}”`}
        </Link>
      )}
      <Typography variant="body1" color="textSecondary">
        {response ? `${response.totalElements} offers found` : 'Searching…'}
      </Typography>
    </Box>
  );
}
